import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  LoadingPopUp,
  TextInputField,
} from "../../../../../common-components";
import { LandingCard } from "../../../../../web-site/components";

const AddNewCard = ({
  display,
  onCloseClick,
  width,
  AddNewCardHandler,
  onImageLink,
  onColorChange,
  imagelink,
  onTagLine,
  onCardChange,
  onInfoLink,
  onSubTitle,
  onPara1,
  onPara2,
  subTitle,
  tagLine,
  cardTitle,
  para1,
  para2,
}) => {
  const [displayedIndex, setDisplayedIndex] = useState(0);

  const backGroundColorSelecto = () => {
    if (displayedIndex === 0) {
      return colors.primaryBlue;
    } else if (displayedIndex === 1) {
      return colors.primaryOrange;
    } else if (displayedIndex === 2) {
      return colors.primaryPink;
    } else if (displayedIndex === 3) {
      return colors.primaryPurple;
    } else if (displayedIndex === 4) {
      return colors.secondaryPink;
    } else if (displayedIndex === 5) {
      return colors.secondaryOrange;
    }
  };
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        position: "absolute",
        top: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        backgroundColor: colors.secondaryGrey,
        transition: "all 0.5s",
        opacity: display ? 1 : 0,
      }}
    >
      <div style={{ position: "absolute", left: 20, top: 20 }}>
        <BaseButtons
          label={"CLOSE"}
          backgroundColor={colors.secondaryOrange}
          borderRadius={8}
          onClick={onCloseClick}
          width={100}
        />
      </div>
      <div
        style={{
          flex: 0.7,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: colors.primaryBlue,
        }}
      >
        <LandingCard
          editorDisplay={true}
          backgroundColorButton={backGroundColorSelecto(0)}
          width={1500}
          display={true}
          info={para1}
          info2={para2}
          cardImage={imagelink}
          imageHeight={300}
          cardtitle={cardTitle ? cardTitle : null}
          subTitle={subTitle ? subTitle : null}
          shortText={tagLine ? tagLine : null}
        />
      </div>
      <div
        style={{
          flex: 0.3,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{ width: "100%", overflowY: "scroll", overflowX: "hidden" }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              height: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            NEW CARD INFORMATION
          </div>
          <TextInputField
            labelTitle={"IMAGE LINK"}
            mini={true}
            onChange={onImageLink}
          />
          <TextInputField
            labelTitle={"CARD TITLE"}
            mini={true}
            onChange={onCardChange}
          />
          <TextInputField
            labelTitle={"TAG LINE"}
            mini={true}
            onChange={onTagLine}
          />
          <TextInputField
            labelTitle={"SUB TITLE"}
            mini={true}
            onChange={onSubTitle}
          />
          <TextInputField
            labelTitle={"PARAGRAPH 1"}
            mini={true}
            onChange={onPara1}
          />
          <TextInputField
            labelTitle={"PARAGRAPH 2"}
            mini={true}
            onChange={onPara2}
          />

          <TextInputField
            labelTitle={"INFO BUTTON LINK"}
            mini={true}
            onChange={onInfoLink}
          />
          <TextInputField
            labelTitle={"NEW COLOR ( HEX VALUE )"}
            mini={true}
            placeholder={"e.g. #FAA919"}
            onChange={onColorChange}
          />
          <div style={{ height: 20 }} />
          <BaseButtons
            backgroundColor={colors.secondaryDarkBlue}
            label={"SAVE CARD"}
            width={"100%"}
            // disabled={true}
            onClick={() => AddNewCardHandler()}
          />
          {/* <div style={{ height: 5 }} /> */}
        </div>
      </div>
    </div>
  );
};

export default AddNewCard;
